import React from 'react';

const Footer = () => {
    return (
        <div className='mt-5'>
            <div>
                <p class="text-center fw-bold text-dark p-4">© copyrights 2022. All rights reserved by Salman</p>
            </div>
        </div>
    );
};

export default Footer;